import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { host_url, token } from "../../../config";
import { triggerNotification } from "../../../component/message/Msg";
import Breadcrumb from "../../../component/breadcrumb/Breadcrumb";
import Spinner from "../../../component/loadingbar/Spinner";
import { formatDate } from "@fullcalendar/core";
import moment from "moment";

const ViewLeadProfile = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [leadProfileData, setLeadProfileData] = useState({});

  //----------------------------------------------- select / get / view LeadProfile ---------------------------------r
  const fetchLeadProfileData = async () => {
    setLoading(true);
    try {
      await fetch(`${host_url}lead-profile/${decodeURIComponent(atob(id))}`, {
        method: "GET",
        headers: {
          token: token,
        },
      })
        .then((response) => response.json())
        .then(async (data) => {
          if (data.status === 200) {
            setLeadProfileData(data.data);
          }
        });
    } catch (error) {
      triggerNotification("error", "Error occurs in fetch data.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id !== undefined) {
      fetchLeadProfileData();
    }
  }, [id]);
  return (
    <>
      <Breadcrumb
        txt="Manage Lead Profile"
        subpath={["View Lead Profiles", "Lead Profile Details"]}
        url={["/viewleadprofiles"]}
      />
      {loading ? (
        <Spinner />
      ) : (
        <div className="container-xxl flex-grow-1 container-p-y mt-12">
          <div className="row">
            <div className="col-12">
              <div className="card mb-4">
                <div className="d-flex py-3 align-items-md-end align-items-sm-start align-items-center justify-content-md-between justify-content-start mx-4 flex-md-row flex-column gap-4">
                  <div className="user-profile-info ">
                    <h4>
                      {leadProfileData.first_name_of_lead +
                        " " +
                        leadProfileData.last_name_of_lead}
                    </h4>
                    <ul className="list-inline mb-0 d-flex align-items-center flex-wrap justify-content-sm-start justify-content-center gap-2">
                      <li className="list-inline-item">
                        <i className="mdi mdi-account  form-icon me-1 mdi-20px"></i>
                        <span className="fw-medium">
                          {leadProfileData.type_of_lead}
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card mb-4">
            <div className="card-body row">
              {/* ---------------------------------- About ---------------------------------- */}
              <div className="col-md-6">
                <small className="card-text text-uppercase">About</small>
                <ul className="list-unstyled my-3 py-1">
                  {/* name */}
                  <li className="d-flex align-items-center mb-3">
                    <i className="mdi mdi-account-outline mdi-24px"></i>
                    <span className="fw-medium mx-2">Full Name:</span>{" "}
                    <span>
                      {leadProfileData.first_name_of_lead +
                        " " +
                        leadProfileData.last_name_of_lead}
                    </span>
                  </li>

                  {/* dob */}
                  <li className="d-flex align-items-center mb-3">
                    <i className="mdi mdi-cake-variant-outline mdi-24px"></i>
                    <span className="fw-medium mx-2">DOB:</span>{" "}
                    <span>
                      {leadProfileData.dob && leadProfileData.dob.slice(8, 10)}/
                      {leadProfileData.dob && leadProfileData.dob.slice(5, 7)}/
                      {leadProfileData.dob && leadProfileData.dob.slice(0, 4)}
                    </span>
                  </li>

                  {/* address */}
                  <li className="d-flex align-items-center mb-3">
                    <i className="mdi mdi-map-marker-outline mdi-24px"></i>
                    <span className="fw-medium mx-2">Address:</span>{" "}
                    <span>{leadProfileData.address_line_1}</span>
                  </li>

                  {/* City, State, Country */}
                  <li className="d-flex align-items-center mb-3">
                    <i className="mdi mdi-map-marker-radius-outline mdi-24px"></i>
                    <span className="fw-medium mx-2">City/State/Country:</span>{" "}
                    <span>
                      {leadProfileData.city}, {leadProfileData.state},{" "}
                      {leadProfileData.country}
                    </span>
                  </li>

                  {/* Postal Code */}
                  <li className="d-flex align-items-center mb-3">
                    <i className="mdi mdi-map-marker-circle mdi-24px"></i>
                    <span className="fw-medium mx-2">Postal Code:</span>{" "}
                    <span>{leadProfileData.postal_code}</span>
                  </li>

                  {/* Gender */}
                  <li className="d-flex align-items-center mb-3">
                    <i className="mdi mdi-gender-male-female mdi-24px"></i>
                    <span className="fw-medium mx-2">Gender:</span>{" "}
                    <span>{leadProfileData.gender}</span>
                  </li>

                  {/* Type Of Lead */}
                  <li className="d-flex align-items-center mb-3">
                    <i className="mdi mdi-account-network-outline mdi-24px"></i>
                    <span className="fw-medium mx-2">Type Of Lead:</span>{" "}
                    <span>{leadProfileData.type_of_lead}</span>
                  </li>

                  {/* Lead Source Type */}
                  <li className="d-flex align-items-center mb-3">
                    <i className="mdi mdi-account-search-outline mdi-24px"></i>
                    <span className="fw-medium mx-2">
                      Lead Source Type:
                    </span>{" "}
                    <span>{leadProfileData.lead_source_type}</span>
                  </li>

                  {/* Reference Code */}
                  <li className="d-flex align-items-center mb-3">
                    <i className="mdi mdi-numeric mdi-24px"></i>
                    <span className="fw-medium mx-2">Reference Code:</span>{" "}
                    <span>{leadProfileData.reference_code}</span>
                  </li>

                  {/* Status */}
                  <li className="d-flex align-items-center mb-3">
                    <i className="mdi mdi-account-box-outline mdi-24px"></i>
                    <span className="fw-medium mx-2">Status:</span>{" "}
                    <span>{leadProfileData.status}</span>
                  </li>

                  {/* Sales Executive */}
                  {/* <li className="d-flex align-items-center mb-3">
                    <i className="mdi mdi-storefront mdi-24px"></i>
                    <span className="fw-medium mx-2">
                      Sales Executive:
                    </span>{" "}
                    <span>{leadProfileData.sales_exe_id}</span>
                  </li> */}
                  {/* Telecom Executive */}
                  {/* <li className="d-flex align-items-center mb-3">
                    <i className="mdi mdi-cellphone mdi-24px"></i>
                    <span className="fw-medium mx-2">
                      Telecom Executive:
                    </span>{" "}
                    <span>{leadProfileData.tele_exec_id}</span>
                  </li> */}

                  {/* Date Of Joining */}
                  <li className="d-flex align-items-center mb-3">
                    <i className="mdi mdi-calendar mdi-24px"></i>
                    <span className="fw-medium mx-2">
                      Date Of Joining:
                    </span>{" "}
                    <span>
                      {" "}
                      {leadProfileData.date_of_joining &&
                        leadProfileData.date_of_joining.slice(8, 10)}
                      /
                      {leadProfileData.date_of_joining &&
                        leadProfileData.date_of_joining.slice(5, 7)}
                      /
                      {leadProfileData.date_of_joining &&
                        leadProfileData.date_of_joining.slice(0, 4)}
                    </span>
                  </li>
                </ul>
              </div>

              {/* ---------------------------------- Contact ---------------------------------- */}
              <div className="col-md-6">
                <small className="card-text text-uppercase">Contacts</small>
                <ul className="list-unstyled my-3 py-1">
                  {/* phone_number */}
                  <li className="d-flex align-items-center mb-3">
                    <i className="mdi mdi-phone-outline mdi-24px"></i>
                    <span className="fw-medium mx-2">Contact:</span>{" "}
                    <span>{leadProfileData.phone_number}</span>
                  </li>
                  {/* Email */}
                  <li className="d-flex align-items-top mb-3">
                    <i className="mdi mdi-email-outline mdi-24px"></i>
                    <div className="">
                      <span className="fw-medium mx-2	">Email:</span>
                    </div>{" "}
                    <div className="row">
                      <span>{leadProfileData.email_1}</span>
                      <span>
                        {leadProfileData.email_2 && leadProfileData.email_2}
                      </span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="card-body row">
              {/* ---------------------------------- History ---------------------------------- */}
              <div>
                <small className="card-text text-uppercase">History</small>
                <div>
                  <div className="px-3 pb-3 row  mt-4  table-responsive">
                    <table className="table table-bordered select-none">
                      <thead>
                        <tr>
                          <td className="col-sm-1">Created At</td>
                          <td>Name</td>
                          <td>Contact</td>
                        </tr>
                      </thead>
                      <tbody>
                        {leadProfileData.history?.map((historyData, i) => (
                          <tr key={i}>
                            <td>
                              {moment(historyData.created_at)?.format(
                                "Do MMM 'YY"
                              )}
                            </td>
                            <td>
                              <div className="">
                                <p className="mb-0">
                                  {historyData.first_name +
                                    " " +
                                    historyData.last_name +
                                    " - " +
                                    historyData.emp_type}
                                </p>
                                <span
                                  className={`badge rounded-pill bg-label-${
                                    historyData.position_type === "Primary"
                                      ? "primary"
                                      : "secondary"
                                  }`}
                                >
                                  {historyData.position_type}
                                </span>
                              </div>
                            </td>
                            <td>
                              <p>{historyData.email}</p>
                              <p>{historyData.mobile_no}</p>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ViewLeadProfile;
